import { Viewer, Worker } from "@react-pdf-viewer/core";

// Plugins
import "@react-pdf-viewer/core/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

function PdfViewer({ url }: { url?: string }) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.js">
      <Viewer fileUrl={`${url}`} plugins={[defaultLayoutPluginInstance]} />
    </Worker>
  );
}

export default PdfViewer;
